import type { ComponentTemplate } from "schemas/generated/componentTemplates";
import type { ReploElement } from "schemas/generated/element";

import { forEachComponentAndDescendants } from "replo-runtime/shared/utils/component";

export const appBlocks: ComponentTemplate = {
  id: "0aeb9ca3-d6f1-4c91-b012-8266a1ebf982",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Shopify/App Blocks",
  leftBarCategory: { main: "pageIntegrations", subCategory: "shopify" },
  preview: "integrations/shopify-app-blocks.svg",
  template: {
    id: "4eeef748-81b9-401c-8e62-83580fd20f91",
    type: "shopifyAppBlocks",
    props: {
      style: {},
    },
  },
  canBeAddedAsChild: ({ element }: { element: ReploElement }) => {
    let canBeAdded = true;
    forEachComponentAndDescendants(element.component, (component) => {
      if (component.type == "shopifyAppBlocks") {
        canBeAdded = false;
        return "stop";
      }
      return "continue";
    });
    if (!canBeAdded) {
      return {
        message:
          "Shopify App Blocks can only be used once in a Shopify Section.",
        canBeAdded: false,
      };
    }

    return {
      canBeAdded: true,
    };
  },
};
